/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Triage state of a report.
 * @export
 */
export const UserReportStatus = {
    Open: 'open',
    InProgress: 'in_progress',
    Resolved: 'resolved',
    Dismissed: 'dismissed'
} as const;
export type UserReportStatus = typeof UserReportStatus[keyof typeof UserReportStatus];


export function instanceOfUserReportStatus(value: any): boolean {
    for (const key in UserReportStatus) {
        if (Object.prototype.hasOwnProperty.call(UserReportStatus, key)) {
            if (UserReportStatus[key as keyof typeof UserReportStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserReportStatusFromJSON(json: any): UserReportStatus {
    return UserReportStatusFromJSONTyped(json, false);
}

export function UserReportStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReportStatus {
    return json as UserReportStatus;
}

export function UserReportStatusToJSON(value?: UserReportStatus | null): any {
    return value as any;
}

export function UserReportStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): UserReportStatus {
    return value as UserReportStatus;
}

